class ComponentCardGrid extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.sidebar = this.querySelector(".component-card-grid__sidebar");
    this.content = this.querySelector(".card-grid__content");
    this.filterButton = this.querySelectorAll("[data-action='toggle-sidebar']");
    this.closeSidebarButtons = this.querySelectorAll(
      "[data-action='close-sidebar']"
    );

    this.toTopButton = this.querySelector(".button__top");
    this.initClickEvents();

    this.initScrollEvents();
  }

  initScrollEvents() {
    let lastScrollY = window.scrollY;
    let ticking = false;

    window.addEventListener(
      "scroll",
      () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            const currentScrollY = window.scrollY;
            const diff = Math.abs(currentScrollY - lastScrollY);

            if (diff > 50) {
              if (currentScrollY < lastScrollY && currentScrollY > 500) {
                this.toTopButton.classList.add("button__top--active");
              } else {
                this.toTopButton.classList.remove("button__top--active");
              }
              lastScrollY = currentScrollY;
            }

            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true } // improves scroll performance
    );
  }

  openSidebar(open = true) {
    if (open)
      this.sidebar?.classList.add("component-card-grid__sidebar--active");
    else this.sidebar?.classList.remove("component-card-grid__sidebar--active");
  }

  resetFilters() {
    const checkboxes = this.sidebar.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
      checkbox.dispatchEvent(new Event("input", { bubbles: true }));
    });
  }

  initClickEvents() {
    this.toTopButton.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
    this.addEventListener("click", (e) => {
      if (!e.target.dataset.action) return;

      switch (e.target.dataset.action) {
        case "close-sidebar":
          this.sidebar.close();
          break;
        case "open-sidebar":
          this.sidebar.open();
          break;
        case "toggle-sidebar":
          this.sidebar.toggle();
          this.filterButton.forEach((button) =>
            button.classList.toggle("filter-button--active")
          );
          break;

        case "reset-filters":
          this.resetFilters();
          break;
        default:
          break;
      }
    });
  }
}

customElements.define("component-card-grid", ComponentCardGrid);

class ComponentCardGridSidebar extends HTMLElement {
  constructor() {
    super();
    this.MOBILE_BREAKPOINT = 990;
  }

  connectedCallback() {
    //this.initResizeEvents();
  }
  initResizeEvents() {
    window.addEventListener(
      "resize",
      debounce(() => {
        if (
          this.filters.classList.contains("open") ||
          this.optionPopup.classList.contains("open")
        )
          document.documentElement.style.overflow = "hidden";

        if (window.innerWidth >= this.MOBILE_BREAKPOINT)
          document.documentElement.style.overflow = "auto";
      }, 150)
    );
  }

  bodyScroll() {
    if (window.innerWidth > this.MOBILE_BREAKPOINT) return;
    document.documentElement.style.overflow = this.classList.contains(
      "component-card-grid__sidebar--active"
    )
      ? "hidden"
      : "auto";
  }

  open() {
    this.classList.add("component-card-grid__sidebar--active");
    this.bodyScroll();
  }
  close() {
    this.classList.remove("component-card-grid__sidebar--active");
    this.bodyScroll();
  }
  toggle() {
    this.classList.toggle("component-card-grid__sidebar--active");
    this.bodyScroll();
  }
}

customElements.define("component-card-grid-sidebar", ComponentCardGridSidebar);

class ComponentLightBox extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector(".lightbox__close");
    this.panzoom = null;
    this.image = this.querySelector("img");
    this.container = this.querySelector(".lightbox__image");
  }
  connectedCallback() {
    this.initClickEvents();
    this.initPanzoom(this.container);
  }

  initPanzoom(container) {
    function clickActions(p) {
      const currentScale = p.getTransform().scale;
      if (currentScale === 1) {
        p.execute("zoomTo", { scale: 2 });
      } else if (currentScale === 2) {
        p.execute("zoomTo", { scale: 3 });
      } else {
        p.execute("zoomTo", { scale: 1 });
      }
    }

    this.panzoom = Panzoom(container, {
      wheelAction: false,
      maxScale: 3,
      minScale: 1,
      dblClick: false,
      clickAction: "base",
      protected: true,
      on: {
        click: clickActions,
      },
    });
  }

  initClickEvents() {
    this.closeButton.addEventListener("click", (e) => this.close());
  }

  toggleBodyScroll() {
    document.documentElement.style.overflow =
      document.documentElement.style.overflow === "hidden" ? "auto" : "hidden";
  }

  generateImage(url) {
    this.container.innerHTML = "";
    const img = new Image();

    img.src = url;
    img.classList.add("f-panzoom__content");
    this.container.appendChild(img);
    this.image = img;
  }

  open() {
    this.classList.add("lightbox--active");
    //this.panzoom.execute("reset");
    if (this.panzoom) this.panzoom.init();

    this.toggleBodyScroll();
  }
  close() {
    this.classList.remove("lightbox--active");
    this.toggleBodyScroll();
    this.panzoom.destroy();
  }
  toggle() {
    this.classList.toggle("lightbox--active");
  }
}

customElements.define("component-lightbox", ComponentLightBox);

class CardGalleryItem extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.lightbox = document.querySelector("component-lightbox");
    this.image = this.querySelector("img");
    // this.classList.add("image-loaded");
    // listen if image is loaded it will add a class
    // this.image.addEventListener("load", () => {
    //   const delay = Math.random() * 300; // random between 0 - 5000 ms
    //   setTimeout(() => {
    //     this.classList.add("image-loaded");
    //   }, delay);
    // });

    const onImageLoad = () => {
      const delay = Math.random() * 300;
      console.log("image loaded");
      setTimeout(() => this.classList.add("image-loaded"), delay);
    };

    this.image.addEventListener("load", onImageLoad);

    // Handle cached image
    if (this.image.complete && this.image.naturalWidth > 0) {
      onImageLoad();
    }

    this.initClickEvents();
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      if (!this.image) return;
      const url = this.image.src.split("?")[0]
        ? this.image.src.split("?")[0]
        : this.image.src;

      // this.lightbox.image.src = this.image.src;
      this.lightbox.generateImage(url + "?width=800");
      // setTimeout(() => {
      this.lightbox.open();
      // }, 200);
    });
  }
}

customElements.define("card-gallery-item", CardGalleryItem);

class ComponentAccordion extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.trigger = this.querySelector("[data-accordion-trigger]");
    this.target = this.querySelector("[data-accordion-target]");
    this.initClickEvents();
  }

  open() {
    this.target.classList.add("accordion--active");
  }
  close() {
    this.target.classList.remove("accordion--active");
  }
  toggle() {
    this.target.classList.toggle("accordion--active");
  }
  initClickEvents() {
    this.trigger.addEventListener("click", (e) => {
      this.toggle();
    });
  }
}

customElements.define("component-accordion", ComponentAccordion);
